import { create } from "zustand";

/**
 * Плывут ли пятна фона.
 *
 * Панели и окна размывают то, что под ними, и пока пятна движутся,
 * `backdrop-filter` пересчитывается с каждым их сдвигом — даже когда в самом
 * приложении ничего не происходит. Сдвигов двенадцать в секунду, а не по
 * кадру (`app/Backdrop.tsx`), но на слабой машине и это заметно.
 * Остановленные пятна стоят там, где их застали, а размытие пересчитывается
 * только тогда, когда под ним что-то меняется.
 *
 * Живёт на этом устройстве, как тема и тон фона.
 */
const KEY = "airel.backdrop-motion";

function read(): boolean {
  try {
    return localStorage.getItem(KEY) !== "off";
  } catch {
    return true;
  }
}

export const useBackdropMotion = create<{ on: boolean }>()(() => ({ on: read() }));

export function setBackdropMotion(on: boolean) {
  useBackdropMotion.setState({ on });
  try {
    localStorage.setItem(KEY, on ? "on" : "off");
  } catch {
    // Без хранилища выключатель доживёт до перезагрузки — большего от него и не ждут.
  }
}
